/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ZapierSubscriptionCreate = {
  target_url: string;
  event_type: ZapierSubscriptionCreate.event_type;
};
export namespace ZapierSubscriptionCreate {
  export enum event_type {
    DOCUMENTS_DOCUMENTREFERENCE_CREATE = 'documents_documentreference.create',
    MEASUREMENTDATE_COMPANYMEASUREMENTDATE_CREATE = 'measurementdate_companymeasurementdate.create',
    MEASUREMENTDATE_COMPANYMEASUREMENTDATE_UPDATE = 'measurementdate_companymeasurementdate.update',
    DASHBOARD_FULFILLMENT_UPDATE = 'dashboard_fulfillment.update',
  }
}
